export default {
    install(Vue) {
        Vue.mixin({
            data(){
                return {
                    clickBtuuonRepeat: false,
                    isShowArr: ['pdf.njczz.com'],
                    isShowArrData:[
                        {url:'pdf.njczz.com',lxr:'陈老师',phone:'15555487515',site:'江苏省南京市六合区龙池街道雄州南路399号恒顺园区110幢一单元201室  ',name:'南京创钟智网络科技有限公司'},
                    ],
                    footerCompany: ['pdf.njczz.com'],
                    matchHostArr : [
                        { host: 'pdf.njczz.com', name: '南京创钟智网络科技有限公司' },
                      ],
                }
            },
            methods:{

                //将url转成对象
                parseQueryString(url) {
                    //url参数转对象
                    url = !url ? window.location.href : url
                    if (url.indexOf('?') === -1) {
                    return null
                    }
                    let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1)
                    if (search === '') {
                    return null
                    }
                    search = search.split('&')
                    let query = {}
                    for (let i = 0; i < search.length; i++) {
                    let pair = search[i].split('=')
                    // query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
                    query[pair[0]] = pair[1] || ''
                    }
                    return query
                },

                isToPdf(){

                }
            }
        })
    }
}